import React, { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
  children: ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  
  @media (min-width: 768px) {
    max-height: 100% !important;
    min-height: 100% !important;
  }

  @media (min-width: 1441px) {
    padding-top: 30px;
  }
  
  @media (max-width: 1440px) {
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    max-width: 100%;
  }
`;

export const Section = (props: Props) => {
  const { children, ...otherProps } = props;
  return <Wrapper {...otherProps}>{children}</Wrapper>;
};
